import { Plus } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import { Reveal } from "./Motion";
import { FAQS } from "../data/portfolio";

export default function Faq() {
  return (
    <section id="faq" className="relative py-24 md:py-36 scroll-mt-20" data-testid="faq">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">Working with Kaya</p>
          <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight leading-[0.95]">
            Questions, <span className="font-serif-accent italic font-normal">answered</span>
          </h2>
          <p className="text-white/55 mt-6 max-w-sm">
            The things clients usually ask before the first call. Anything else, just ask.
          </p>
        </Reveal>

        <Reveal className="lg:col-span-8" delay={0.1}>
          <Accordion type="single" collapsible className="border-t border-white/10" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 md:py-7 text-left text-lg md:text-xl font-display font-semibold tracking-tight text-white/85 hover:text-white hover:no-underline gap-6 [&>svg:last-child]:hidden [&[data-state=open]_.faq-plus]:rotate-45"
                >
                  <span>{f.q}</span>
                  <span className="faq-plus shrink-0 text-white/40 transition-transform duration-300" aria-hidden>
                    <Plus size={18} />
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-7 text-white/60 text-base leading-relaxed max-w-2xl" data-testid={`faq-answer-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
